export default __webpack_public_path__ + "static/media/cp_geo_ag.cd5f7986.svg";